import { FlexContainer } from '@bos/ui';

import { AppDialog } from '../../../../components/AppDialog';
import { AppHorizontalDivider } from '../../../../components/AppHorizontalDivider';
import { AppText } from '../../../../components/AppText/AppText';
import { useI18nContext } from '../../../../locale/i18n-react';

type AccessDeniedReasonsDialogProps = {
	onClose: () => void;
};

export const AccessDeniedReasonsDialog = ({
	onClose,
}: AccessDeniedReasonsDialogProps) => {
	const {
		LL: { accessDeniedPage: accessDeniedPageTranslate },
	} = useI18nContext();

	const reasonsDialogTitle = accessDeniedPageTranslate.reasonsDialog.title();
	const legalPersonReason =
		accessDeniedPageTranslate.reasonsDialog.legalPersonReason();
	const legalPersonDescription =
		accessDeniedPageTranslate.reasonsDialog.legalPersonDescription();
	const blockedAccessReason =
		accessDeniedPageTranslate.reasonsDialog.blockedAccessReason();
	const blockedAccessDescription =
		accessDeniedPageTranslate.reasonsDialog.blockedAccessDescription();
	const historicalAccessNote =
		accessDeniedPageTranslate.reasonsDialog.historicalAccessNote();

	return (
		<AppDialog
			title={reasonsDialogTitle}
			open
			onOutsideClick={onClose}
			onClose={onClose}
		>
			<FlexContainer direction={'column'} gap={'2'}>
				<FlexContainer direction={'column'} gap={'1'}>
					<FlexContainer direction={'column'} gap={'1/2'}>
						<AppText variant={'s1'}>{legalPersonReason}</AppText>
						<AppText variant={'b2'} color={'grey'}>
							{legalPersonDescription}
						</AppText>
					</FlexContainer>
					<AppHorizontalDivider />
					<FlexContainer direction={'column'} gap={'1/2'}>
						<AppText variant={'s1'}>{blockedAccessReason}</AppText>
						<AppText variant={'b2'} color={'grey'}>
							{blockedAccessDescription}
						</AppText>
					</FlexContainer>
					<AppHorizontalDivider />
					<AppText variant={'b2'} color={'grey'}>
						{historicalAccessNote}
					</AppText>
				</FlexContainer>
			</FlexContainer>
		</AppDialog>
	);
};
